import { htmlToReactNode } from '@modules/prism-client/lib/html-to-react-node';

import type PrismAPI from '@modules/prism-client/types/prism-types';
import type { FC } from 'react';

type Props = {
  data: PrismAPI.Html | string | undefined;
};

export const Html: FC<Props> = ({ data }) => {
  return htmlToReactNode(data);
};
